import{ Api } from "../Api";
require('dotenv');
const axios = require('axios').default;


let EmailSupervisorApi =
{
    endpoint : "EmailSupervisor/",

    async update(submission) {
        const URL = process.env.REACT_APP_API_ENDPOINT + this.endpoint

        const response = await axios.post(URL, submission, {withCredentials:true});
        return response.data;
    }
}

//Assign Api Mixin 
EmailSupervisorApi = Object.assign({}, Api, EmailSupervisorApi);

export { EmailSupervisorApi }
